var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("q-page", { staticClass: "flex flex-center" }, [
    _c("p", { staticClass: "text-faded" }, [_vm._v("Notifications")])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }